import { DISPLAY_OPTION_FIELD_INPUTS } from "@circle-react-shared/ProfileFields/constants";

import { PAGE_QUERY_PARAM } from "@/react/components/SettingsApp/ProfileFields/ManageFields/constants";

interface ProfileFieldManageSignupParams {
  prevLocation?: string;
}

export const memberSettingsPaths = {
  index: () => "/settings/audience/manage" as const,
  profileFieldList: () => "/settings/profile_fields" as const,
  profileFieldManage: () => "/settings/profile_fields/manage" as const,
  profileFieldManageSignup: ({
    prevLocation,
  }: ProfileFieldManageSignupParams = {}) => ({
    pathname: "/settings/profile_fields/manage",
    search: `${PAGE_QUERY_PARAM}=${DISPLAY_OPTION_FIELD_INPUTS.SIGNUP}`,
    state: { prevLocation },
  }),
};
